const TipoFrete = {
    FROTA: 1,
    TERCEIRO: 2
};

export default TipoFrete;
